import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Zap, Menu, X } from 'lucide-react';

const Navigation = ({ onBookingClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-0 w-full bg-black/20 backdrop-blur-lg border-b border-white/10 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="flex items-center space-x-3"
          >
            <Link to="/" className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-r from-emerald-400 to-emerald-600 rounded-xl flex items-center justify-center">
                <Zap className="w-6 h-6 text-white" />
              </div>
              <div>
                <h1 className="text-xl font-bold bg-gradient-to-r from-white to-emerald-400 bg-clip-text text-transparent">
                  Agami Cabs
                </h1>
                <p className="text-xs text-emerald-400 font-medium">You first, always</p>
              </div>
            </Link>
          </motion.div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <Link 
              to="/" 
              className={`transition-colors duration-300 ${
                isActive('/') ? 'text-emerald-400' : 'text-white/80 hover:text-emerald-400'
              }`}
            >
              Home
            </Link>
            <a 
              href="/#services" 
              className="text-white/80 hover:text-emerald-400 transition-colors duration-300"
            >
              Services
            </a>
            <a 
              href="/#fleet" 
              className="text-white/80 hover:text-emerald-400 transition-colors duration-300"
            >
              Fleet
            </a>
            <Link 
              to="/about" 
              className={`transition-colors duration-300 ${
                isActive('/about') ? 'text-emerald-400' : 'text-white/80 hover:text-emerald-400'
              }`}
            >
              About
            </Link>
            <a 
              href="/#contact" 
              className="text-white/80 hover:text-emerald-400 transition-colors duration-300"
            >
              Contact
            </a>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={onBookingClick}
              className="bg-gradient-to-r from-emerald-500 to-emerald-600 px-6 py-2 rounded-full text-white font-semibold hover:from-emerald-600 hover:to-emerald-700 transition-all duration-300 shadow-lg hover:shadow-emerald-500/25"
            >
              Book Now
            </motion.button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-white"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="md:hidden bg-black/90 backdrop-blur-lg border-t border-white/10"
        >
          <div className="px-4 py-4 space-y-4">
            <Link 
              to="/" 
              className={`block transition-colors duration-300 ${
                isActive('/') ? 'text-emerald-400' : 'text-white/80 hover:text-emerald-400'
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </Link>
            <a 
              href="/#services" 
              className="block text-white/80 hover:text-emerald-400"
              onClick={() => setIsMenuOpen(false)}
            >
              Services
            </a>
            <a 
              href="/#fleet" 
              className="block text-white/80 hover:text-emerald-400"
              onClick={() => setIsMenuOpen(false)}
            >
              Fleet
            </a>
            <Link 
              to="/about" 
              className={`block transition-colors duration-300 ${
                isActive('/about') ? 'text-emerald-400' : 'text-white/80 hover:text-emerald-400'
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              About
            </Link>
            <a 
              href="/#contact" 
              className="block text-white/80 hover:text-emerald-400"
              onClick={() => setIsMenuOpen(false)}
            >
              Contact
            </a>
            <button 
              onClick={() => {
                onBookingClick();
                setIsMenuOpen(false);
              }}
              className="w-full bg-gradient-to-r from-emerald-500 to-emerald-600 px-6 py-2 rounded-full text-white font-semibold"
            >
              Book Now
            </button>
          </div>
        </motion.div>
      )}
    </nav>
  );
};

export default Navigation;